"use strict";

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessage(data) {
    $.spinner().stop();
    var status;
    if (data.success && !data.isRemoveProduct) {
        status = "alert-success";
    } else {
        status = "alert-danger";
    }

    if ($(".add-to-wishlist-messages").length === 0) {
        $("body").append(
            "<div class=\"add-to-wishlist-messages \"></div>"
        );
    }

    $(".add-to-wishlist-messages")
        .append("<div class=\"alert add-to-wishlist-alert text-center " + status + "\">" + data.msg + "</div>");

    setTimeout(function () {
        $(".add-to-wishlist-messages").remove();
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $(".add-to-wish-list").on("click", function (e) {
            e.preventDefault();
            var $button = $(this);
            var isRemoveFromWishlist = $button.hasClass("wishlist-added");
            var url = isRemoveFromWishlist ? $button.data("remove-url") : $button.data("href");
            var pid = $button.closest(".product-detail").find(".product-id").html();
            var optionId = $button.closest(".product-detail").find(".product-option").attr("data-option-id");
            var optionVal = $button.closest(".product-detail").find(".options-select option:selected").attr("data-value-id");
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: isRemoveFromWishlist ? "get" : "post",
                dataType: "json",
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal,
                    triggeredFrom: "Product-Show"
                },
                success: function (data) {
                    $.spinner().stop();

                    if (data.isGuest) {
                        var $loginModal = $("#loginModal");
                        var $loginModalLink = $loginModal.find(".login-modal-link");

                        if ($loginModalLink.length) {
                            $loginModalLink.attr("href", data.loginUrl);
                            $loginModal.modal("show");
                        }
                    } else {
                        displayMessage(data, $button);
                        $button.toggleClass("wishlist-added");
                    }
                },
                error: function (err) {
                    $.spinner().stop();

                    displayMessage(err, $button);
                }
            });
        });
    }
};
